export default class ClassNames {
    public static SidebarMenuOpened: string = 'sidebar--hamburger-opened';
    public static OverlayVisible: string = 'overlay--visible';
    public static SidebarPanelCollapsed: string = 'sidebar--panel-collapsed';
}